import { defineStore } from "pinia";

export const useCandleStore  = defineStore("useCandleStore", {
    state: () => {
        return {
            candles: 10,
            isLastStand: false,
            players: 5,
            isTruthsTime: false,
            gameVersion: "v1.0.1"
        }
    },
    actions:{
        loseACandle(){
            this.candles -= 1;
        }
    }
});